// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b2780744","229":"aa81e95b","239":"7963416c","342":"bdcc1233","453":"4bc95cd4","495":"60146196","667":"eb73c924","712":"deb06fda"}[chunkId] + ".chunk.js";
};